import { RadioWidget } from '#components/RadioWidget';
import { useBreakpoint } from '#cutils/hooks/useBreakpoint';
import type { KiAssistant } from '#domains/resolver/board-section-data';

import { BoardSectionKiAssistant } from './BoardSectionKiAssistant';

type Props = {
	kiAssistant: KiAssistant | undefined;
	className?: string;
};

export function BoardSectionEmbedWidget({ kiAssistant, className }: Props) {
	const isDesktop = useBreakpoint('lg');

	if (kiAssistant) {
		return <BoardSectionKiAssistant kiAssistant={kiAssistant} className={className} enableViewMode={isDesktop} />;
	} else {
		return <RadioWidget className={className} />;
	}
}
